import { config } from "../../utils/Constants";
import {
  addHttpRecorderRecord,
  getHttpRecorderSnapshot,
} from "./httpRecorderStore";

let requestCounter = 0;

const sendRemoteLog = (logData) => {
  // if (
  //   process.env.NODE_ENV === "development" ||
  //   window.location.hostname === "localhost"
  // ) {
  //   return;
  // }
  const baseUrl = config?.webBaseUrl
    ? config.webBaseUrl.replace(/\/$/, "")
    : "https://utilities.suyool.com";
  const logApiUrl = `${baseUrl}/api/logs`;

  let messagePayload = "";
  try {
    messagePayload = JSON.stringify(logData);
  } catch (e) {
    messagePayload = "Failed to stringify log data";
  }

  const payload = {
    app_id: 1,
    message: messagePayload,
  };

  const fetchOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-API-Key": process.env.REACT_APP_UTILITIES_API_KEY || "",
      // Authorization: sessionStorage.getItem("Token")
    },
    body: JSON.stringify(payload),
  };

  fetch(logApiUrl, fetchOptions)
    .then(async (response) => {
      if (!response.ok) {
        try {
          const errorText = await response.text();
          console.error("sendRemoteLog error response body:", errorText);
        } catch (e) {
          console.error("sendRemoteLog failed to read error response body", e);
        }
      }
    })
    .catch((err) => {
      console.error("sendRemoteLog fetch error:", err);
    });
};

const redactHeaders = (headers = {}) => {
  const plainHeaders =
    typeof headers.toJSON === "function" ? headers.toJSON() : { ...headers };

  Object.keys(plainHeaders).forEach((header) => {
    if (/^(authorization|x-api-key)$/i.test(header)) {
      plainHeaders[header] = "[REDACTED]";
    }
  });

  return plainHeaders;
};

const buildUrl = (config = {}) => `${config.baseURL || ""}${config.url || ""}`;
const createRequestId = (name) => `${name}-${Date.now()}-${++requestCounter}`;

export const attachHttpRecorder = (client, name = "api") => {
  client.interceptors.request.use(
    (config) => {
      const isRecording = getHttpRecorderSnapshot().isRecording;

      const requestId = createRequestId(name);

      config.metadata = {
        ...(config.metadata || {}),
        requestId,
        startTime: Date.now(),
      };

      const requestLog = {
        type: "request",
        scope: name,
        requestId,
        method: config.method,
        url: buildUrl(config),
        headers: redactHeaders(config.headers),
        params: config.params,
        data: config.data,
      };

      if (isRecording) {
        addHttpRecorderRecord(requestLog);
      }
      sendRemoteLog(requestLog);

      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  client.interceptors.response.use(
    (response) => {
      if (!response.config?.metadata?.requestId) {
        return response;
      }

      const requestId = response.config.metadata.requestId;
      const startTime = response.config.metadata.startTime;
      const durationMs =
        typeof startTime === "number" ? Date.now() - startTime : undefined;

      const responseLog = {
        type: "response",
        scope: name,
        requestId,
        durationMs,
        status: response.status,
        url: buildUrl(response.config),
        data: response.data,
      };

      if (getHttpRecorderSnapshot().isRecording) {
        addHttpRecorderRecord(responseLog);
      }
      sendRemoteLog(responseLog);

      return response;
    },
    (error) => {
      if (!error?.config?.metadata?.requestId) {
        return Promise.reject(error);
      }

      const requestId = error.config.metadata.requestId;
      const startTime = error.config.metadata.startTime;
      const durationMs =
        typeof startTime === "number" ? Date.now() - startTime : undefined;

      const errorLog = {
        type: "response-error",
        scope: name,
        requestId,
        durationMs,
        status: error?.response?.status,
        url: buildUrl(error.config),
        data: error?.response?.data,
        message: error.message,
      };

      if (getHttpRecorderSnapshot().isRecording) {
        addHttpRecorderRecord(errorLog);
      }
      sendRemoteLog(errorLog);

      return Promise.reject(error);
    },
  );

  return client;
};
